export enum TiposForm {
	VISUALIZAR = 'visualizar',
	EDITAR = 'editar',
	ADICIONAR = 'adicionar',
}
